<template>
  <button
    :id="props.id"
    @click.prevent="handleClick"
    :class="[...props.classes, loading && 'loading']"
    :disabled="props.disabled"
    :loading="props.loading"
    class="position-relative"
  >
    <div class="loader position-absolute button-primary opacity-75" v-if="loading"></div>
    <div class="svg-slot">
      <slot name="svg" />
    </div>
    <span
      class="text-slot"
      :class="[!props.disabled ? props.textClass : 'text-primary-white']"
    >
      <slot name="text"></slot>
    </span>
  </button>
</template>

<script lang="ts" setup>
  import { defineProps, defineEmits, withDefaults } from 'vue'

  interface Props {
    id?: string
    disabled?: boolean
    classes?: string[]
    textClass?: string
    loading?: boolean
  }
  interface Emits {
    (e: 'buttonClick'): void
  }

  // props
  const props = withDefaults(defineProps<Props>(), {
    classes: () => ['button-primary', 'bg-primary-blue'],
    textClass: 'text-primary-white',
  })

  // emit
  const emit = defineEmits<Emits>()

  // handlers
  const handleClick = () => {
    if (props.disabled) return
    emit('buttonClick')
  }
</script>

<style scoped>
.loader {
  background-color: var(--primary-blue) !important;
  opacity: .85;
  background-size: 10em;
}

.button-primary.loading:disabled {
    background-color: var(--primary-blue);
} 
</style>
